import Api from '../api';

class IntegrationServices {
  static getAddressManagersPhones({ addressId }) {
    return Api.getAddressManagersPhones({ addressId });
  }

  static saveAddressManagersPhones({ addressId, managersPhones }) {
    return Api.saveAddressManagersPhones({
      addressId,
      managers_phones: managersPhones
        .map((p) => String(p ?? '').replace(/\D/g, ''))
        .filter(Boolean),
    });
  }
}

export default IntegrationServices;
